app.controller('OrderReplacementEntryAddController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {


    const siteHelper = $rootScope.site_helper;
    $scope.order_id = $stateParams.order_id;
    $scope.waiting_for_data = !!$scope.order_id;

    $scope.visible_order = null;

    $scope.replacement_order = {};
    $scope.replacement_order.lines = [];

    $scope.view_model = {
        page_state: "add_faults",
        selected_order_line_index: ""
    }

    $rootScope.model.order_replacement.requireFaultTypes();

    let documentProductTag = "replacement_order" ;

    $scope.replacement_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([documentProductTag], function (documents) {
        $scope.replacement_document = documents.length > 0 ? documents[0] : null;
        console.log($scope.replacement_document)
    })

    function createFileUploadModel(finalFiles, prefix){
        const model = {
            config_id: "replacement_image"
        };
        if(finalFiles){
            model.final_files = finalFiles;
            model.prefix = prefix;
        }
        return model
    }

    function allFileUploadModels(){
        const models = [];
        for (let i = 0; i < $scope.replacement_order.lines.length; i++) {
            const replacementLine = $scope.replacement_order.lines[i];
            const replacementLineItems = $scope.getLineItems(replacementLine);
            for(let j = 0; j < replacementLineItems.length; j++) {
                const replacementLineItem = replacementLine.line_items[j];
                if(replacementLineItem.file_upload_model.initialized){
                    models.push(replacementLineItem.file_upload_model);
                }
            }
        }
        if($scope.replacement_order.file_upload_model.initialized){
            models.push($scope.replacement_order.file_upload_model);
        }

        return models;
    }

    $scope.getLineItems = function (replacementLine)
    {
        if(!replacementLine.line_items){
            replacementLine.line_items = [];
        }
        let isHidden = false;
        if(!replacementLine.fault_type){
            let initialized = false
            for(let i = 0; i < replacementLine.line_items.length; i++) {
                const replacementLineItem = replacementLine.line_items[i];
                if(replacementLineItem.file_upload_model.initialized){
                    initialized = true;
                    break;
                }
            }
            if(!initialized){
                isHidden = true;
            }
        }
        const itemCount = isHidden || !replacementLine.quantity || replacementLine.quantity < 1 ? 0 : parseInt(replacementLine.quantity);
        if(itemCount < replacementLine.line_items.length){
            replacementLine.line_items.length = itemCount;
        } else {
            for(let i = replacementLine.line_items.length; i < itemCount; i ++){

                const image_urls = [];
                replacementLine.line_items.push({
                    image_urls: image_urls,
                    file_upload_model: createFileUploadModel(image_urls, imagePrefix(i)),
                    no_photo: false
                })
            }
        }

        return replacementLine.line_items;

    }

    function imagePrefix(itemIndex){
        const replacementDatePrefix = "date-"+(new Date().toISOString().split('.')[0]).split("T").join("").split("-").join("").split(":").join("");
        return replacementDatePrefix+"-item-"+itemIndex+"-";
    }

    $scope.fileUploadInProgress = function () {
        const fileUploadModels = allFileUploadModels();
        for (let i = 0; i < fileUploadModels.length; i++) {
            if(fileUploadModels[i].in_progress_states.length){
                return true;
            }
        }
        return false;
    }

    $scope.photoNotExpected = function (replacementLine) {
        const missingFaultType = 14;
        return replacementLine.fault_type === missingFaultType;
    }

    function cleanupFileUploadModels() {
        const fileUploadModels = allFileUploadModels();
        for (let i = 0; i < fileUploadModels.length; i++) {
            fileUploadModels[i].cleanup = true;
        }
    }

    if ($scope.waiting_for_data) {
        $rootScope.service.account.requireMinimumData(function () {
            $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {

                $scope.visible_order = success && $rootScope.service.order_helper.isOrderSubmitted(order) ? order : null;
                $scope.waiting_for_data = false;
                if(!$scope.visible_order){
                    return
                }
                $scope.visible_order = JSON.parse(JSON.stringify($scope.visible_order))
                $scope.visible_order.lines = $scope.visible_order.lines ? $scope.visible_order.lines : [];
                for(let i = 0; i < $scope.visible_order.lines.length; i++){
                    const orderLine = $scope.visible_order.lines[i];
                    orderLine.order_line_index = i;
                    orderLine.quantity = orderLine.quantity ? orderLine.quantity: 0;
                    const description = siteHelper.anyDescription(orderLine);
                    orderLine.description = description;
                    let fullDescription = orderLine.quantity + " x " + description;
                    if(orderLine._subtext){
                        let subtext = "";
                        for(let key in orderLine._subtext){
                            if(subtext){
                                subtext += ", ";
                            }
                            subtext += orderLine._subtext[key];
                        }
                        if(subtext){
                            fullDescription += " ("+subtext+")";
                        }
                    }
                    orderLine.full_description = fullDescription;
                }
                $scope.replacement_order.type = "replacement";
                $scope.replacement_order.order_id = $scope.order_id;
                $scope.replacement_order.delivery_address = {};

                $scope.replacement_order.image_urls = [];
                $scope.replacement_order.file_upload_model = createFileUploadModel($scope.replacement_order.image_urls);
                $scope.view_model.selected_order_line_index = "";
            });
        });
    }

    $scope.availableLines = function () {
        const availableLines = []
        for(let i = 0; i < $scope.visible_order.lines.length; i++) {
            const orderLine = $scope.visible_order.lines[i];
            let remaining = orderLine.quantity;
            for(let j = 0; j < $scope.replacement_order.lines.length; j ++){
                const replacementLine = $scope.replacement_order.lines[j];
                if(replacementLine.order_line_index === orderLine.order_line_index){
                    remaining -= replacementLine.quantity;
                }
            }
            if(remaining > 0){
                availableLines.push(orderLine);
            }
        }
        return availableLines;
    }

    $scope.addReplacementLine = function () {
        const index = $scope.view_model.selected_order_line_index || $scope.view_model.selected_order_line_index === 0 ? parseInt($scope.view_model.selected_order_line_index) : -1;
        if(index >= 0){
            let orderLine = $scope.visible_order.lines[index];
            if(orderLine){
                const replacementLine = JSON.parse(JSON.stringify(orderLine));
                replacementLine.signature = replacementLine._signature;
                replacementLine.fault_type = "";
                replacementLine.ordered_quantity = replacementLine.quantity;
                replacementLine.quantity = 1;
                replacementLine.image_urls = [];
                $scope.replacement_order.lines.push(replacementLine);
            }
        }
        $scope.view_model.selected_order_line_index = "";
    }

    $scope.removeReplacementLine = function (replacementLine) {
        $scope.replacement_order.lines.splice($scope.replacement_order.lines.indexOf(replacementLine), 1);
        if ($scope.replacement_order.lines.length === 0) {
            $scope.showAddFaults();
        }
    }

    $scope.have_minimum_line_data = function (){
        if(!$scope.replacement_order.lines.length){
            return false
        }
        for(let i = 0; i < $scope.replacement_order.lines.length; i ++) {
            const replacementLine = $scope.replacement_order.lines[i];
            if(!replacementLine.fault_type){
                return false
            }
        }
        return true;
    }

    $scope.validateQuantity = function (replacementLine){
        replacementLine.quantity = replacementLine.quantity ? parseInt(replacementLine.quantity) : 0;
        replacementLine.quantity = Math.max(replacementLine.quantity, 1);
        if(replacementLine.quantity === 1){
            return;
        }
        let max = replacementLine.ordered_quantity;
        for(let i = 0; i < $scope.replacement_order.lines.length; i ++){
            const altLine = $scope.replacement_order.lines[i];
            if(altLine === replacementLine){
                continue;
            }
            if(altLine.order_line_index === replacementLine.order_line_index){
                max -= replacementLine.quantity;
            }
        }
        max = Math.max(max, 1);
        replacementLine.quantity = Math.min(replacementLine.quantity, max);
    }

    $scope.showEnterDetails = function () {
        cleanupFileUploadModels();
        collectLineImageURLs();
        $scope.view_model.page_state = "enter_details";
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    $scope.showAddFaults = function () {
        $scope.view_model.page_state = "add_faults";
    }

    $scope.getDeliveryAddress = function () {
        return $scope.replacement_order.delivery_address;
    }

    function collectLineImageURLs(){
        for (let i = 0; i < $scope.replacement_order.lines.length; i++) {
            const replacementLine = $scope.replacement_order.lines[i];
            replacementLine.image_urls = [];
            const replacementLineItems = $scope.getLineItems(replacementLine);
            for(let j = 0; j < replacementLineItems.length; j++) {
                const replacementLineItem = replacementLine.line_items[j];
                replacementLine.image_urls = replacementLine.image_urls.concat(replacementLineItem.image_urls);
            }
        }
    }

    $scope.submitReplacementOrder = function (validateFormCallback) {
        cleanupFileUploadModels();
        $scope.form_disabled = true;
        collectLineImageURLs();
        const replacementOrder = JSON.parse(JSON.stringify($scope.replacement_order));
        delete replacementOrder.file_upload_model;
        for (let i = 0; i < replacementOrder.lines.length; i++) {
            const replacementLine = replacementOrder.lines[i];
            delete replacementLine.line_items;
        }

        $rootScope.service.order_replacement.submitReplacementOrder(replacementOrder, function (success, replacement_order, messages) {
            $scope.form_disabled = false;
            if (success) {
                $state.go('myba.order-replacement-entry-acknowledgement', {replacement_id: replacement_order._id});
            }
            validateFormCallback(success, messages);
        });

    };



}]);